// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ie-0";
export var actionModalContentContainer = "_ie-1";
export var createTagButton = "_ie-2";
export var footerContainer = "_ie-7";
export var fullWidthDivider = "_ie-3";
export var hasCreateTagButton = "_ie-4";
export var noCreateTagButton = "_ie-5";
export var tagsContainer = "_ie-6";
export var tagsModalContentContainer = "_ie-8";